'use client';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from '@/components/ui/Accordian';
import { faqs } from '@/lib/config/faq';
import { usePageView } from '@/lib/hooks/usePageView';
import Link from 'next/link';
import { ArrowRight, HelpCircle, MessageCircle } from 'lucide-react';

export default function FAQ() {
  usePageView();
  
  return (
    <section className="w-full max-w-4xl mx-auto px-4 py-16 md:py-24">
      {/* Header */}
      <div className="text-center mb-16">
        <p className="text-amber-500 font-semibold text-sm uppercase tracking-wider mb-3">
          FAQ
        </p>
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
          Frequently Asked
          <span className="bg-gradient-to-r from-amber-500 to-amber-700 bg-clip-text text-transparent">
            {" "}Questions
          </span>
        </h1>
        <p className="text-lg text-slate-400 max-w-2xl mx-auto">
          Everything you need to know about Easy Pairing. Can&apos;t find what you&apos;re looking for? Contact our support team.
        </p>
      </div>

      {/* FAQ Accordion */}
      <Accordion
        type="multiple"
        className="space-y-4"
      >
        {faqs.map((item, index) => (
          <AccordionItem 
            key={item.question} 
            value={`item-${index}`}
            className="bg-slate-900/50 backdrop-blur-sm rounded-xl border border-white/5 hover:border-amber-600/20 px-6 transition-all duration-300"
          >
            <AccordionTrigger className="text-base md:text-lg font-semibold text-white py-5 hover:text-amber-500 transition-colors [&[data-state=open]]:text-amber-500">
              <div className="flex items-center gap-3 text-left">
                <HelpCircle className="w-5 h-5 text-slate-500 flex-shrink-0" />
                {item.question}
              </div>
            </AccordionTrigger>
            <AccordionContent className="text-base text-slate-400 pb-5 pl-8 leading-relaxed">
              {item.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      {/* Contact CTA */}
      <div className="mt-16 text-center">
        <div className="inline-flex flex-col sm:flex-row items-center gap-4 p-6 rounded-2xl bg-slate-900/50 border border-white/5">
          <div className="p-3 rounded-xl bg-amber-700/15">
            <MessageCircle className="w-6 h-6 text-amber-500" />
          </div>
          <div className="text-center sm:text-left">
            <p className="text-white font-medium">Still have questions?</p>
            <p className="text-slate-400 text-sm">We&apos;re here to help</p>
          </div>
          <Link 
            href="/contact"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-amber-600 to-amber-700 text-white font-medium hover:from-amber-700 hover:to-amber-800 transition-all"
          >
            Contact Support
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
